import React from 'react';
import './EmailButton.css';

function onClick() {
  const addr = 'info';
  const domain = 'westpoint.se';
  const url = `mailto:${addr}@${domain}`;

  window.location = url;
}

export default function EmailButton() {
  return (
    <button className="email-button" onClick={onClick}>
      <svg
        className="email-button-svg"
        width="17px"
        height="17px"
        viewBox="0 0 17 17"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0,0 L3.066,16.351 L8.175,12.263 L12.262,15.328 L12.262,10.22 L16.349,7.154 L0,0 Z M0.218,0.198 L10.955,9.483 L9.531,10.45 L0.218,0.198 Z"
          id="Shape"
        />
      </svg>
    </button>
  );
}



// WEBPACK FOOTER //
// ./src/components/EmailButton.js